module.exports = __webpack_public_path__ + "imgs/share-qr@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/share-qr@2x.png
// module id = 229
// module chunks = 93